/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import * as globals from "../globals";

export default function CaseCounter(props) {
  return (
    <div
      css={css`
        ${globals.card}
        text-align: left;

        h2 {
          font-size: 36px;
          margin: 4px 0;
          text-transform: uppercase;
          padding: 0 12px;
          color: #fff;
          background-color: #000;
          display: inline-block;
        }

        h5 {
          font-size: 16px;
          margin: 0;
          text-transform: uppercase;
        }

        p {
          text-align: right;
          font-size: 10px;
          font-style: italic;
          margin: 2px 0 0;
        }
      `}
    >
      <h2>{props.cases.ucla}</h2>
      <h5>confirmed cases</h5>
      <h5>in the UCLA community</h5>
      <h2 style={{ marginTop: "12px" }}>{props.cases.la}</h2>
      <h5>confirmed cases</h5>
      <h5>in LA County</h5>
      <p>last updated {props.cases.updated}</p>
    </div>
  );
}
